// Starts loading a product's quick view as soon as the shopper points at
// (or touches) the card's "+" button, so the popup opens without a wait.
// The theme's quick view calls fetchSection('product-quickview', { url });
// this wraps fetchSection to reuse the prefetched response.
(function () {
  if (window.__fbQuickviewPrefetch) return;
  window.__fbQuickviewPrefetch = true;

  var cache = new Map();

  function productUrl(handle) {
    return (window.MinimogSettings && window.MinimogSettings.base_url || '/') + 'products/' + handle;
  }

  function wrap() {
    if (typeof window.fetchSection !== 'function' || window.fetchSection.__fbWrapped) return false;
    var original = window.fetchSection;
    var wrapped = function (sectionId, options) {
      options = options || {};
      if (sectionId === 'product-quickview' && options.url) {
        var key = String(options.url);
        var pending = cache.get(key);
        if (pending) {
          cache.delete(key);
          // Hand the theme a fresh copy so it can move nodes into the modal
          return pending.then(function (dom) { return dom.cloneNode(true); });
        }
      }
      return original.apply(this, arguments);
    };
    wrapped.__fbWrapped = true;
    window.fetchSection = wrapped;
    return true;
  }

  var stylesLoaded = false;
  function prefetch(handle) {
    if (!handle || !wrap()) return;
    var url = productUrl(handle);
    if (!cache.has(url)) {
      var request = new Promise(function (resolve, reject) {
        var u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', 'product-quickview');
        fetch(u, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('quickview'); return r.text(); })
          .then(function (html) {
            // Same shape as the theme's generateDomFromString()
            var div = document.createElement('div');
            div.innerHTML = html;
            resolve(div);
          })
          .catch(reject);
      });
      request.catch(function () { cache.delete(url); });
      cache.set(url, request);
    }
    if (!stylesLoaded && typeof window.loadAssetsNew === 'function' && window.MinimogThemeStyles) {
      stylesLoaded = true;
      try { window.loadAssetsNew([window.MinimogThemeStyles.product], 'quick-view-assets'); } catch (e) {}
    }
  }

  function buttonFor(target) {
    if (!target.closest) return null;
    var btn = target.closest('.fb-card-quick');
    if (btn) return btn;
    var card = target.closest('.m-product-card');
    return card && card.querySelector('.fb-card-quick');
  }

  // Mouse: prefetch once the pointer rests on a card for a moment
  var hoverTimer, hoverCard;
  document.addEventListener('pointerover', function (e) {
    var card = e.target.closest && e.target.closest('.m-product-card');
    if (card === hoverCard) return;
    hoverCard = card;
    clearTimeout(hoverTimer);
    var btn = card && card.querySelector('.fb-card-quick');
    if (btn) hoverTimer = setTimeout(function () { prefetch(btn.dataset.productHandle); }, 150);
  }, { passive: true });

  // Touch / keyboard: prefetch straight away
  function now(e) {
    var btn = buttonFor(e.target);
    if (btn) prefetch(btn.dataset.productHandle);
  }
  document.addEventListener('touchstart', now, { passive: true });
  document.addEventListener('pointerdown', now, { passive: true });
  document.addEventListener('focusin', now);
})();

// Sizes on product cards: mark the card once the shopper picks a size,
// so the theme's pre-selected size is only highlighted after a real choice.
(function () {
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.m-product-card .m-product-option--node__label');
    if (!label) return;
    if (label.classList.contains('m-product-option--node__label--sold-out')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    label.closest('.m-product-card').classList.add('fb-size-picked');
  }, true);
})();

// Collection layout switch (toolbar grid icons). The theme's collection.js
// only toggles the button state, so this applies the column class itself.
// Desktop: 2/3/4 columns, mobile: 1/2 columns; remembered per device.
(function () {
  function isMobile() { return window.innerWidth < 768; }
  function key() { return isMobile() ? 'fbGridColsMobile' : 'fbGridColsDesktop'; }
  function allowed(n) { return isMobile() ? (n === 1 || n === 2) : (n >= 2 && n <= 4); }
  function stored() {
    var n = 0;
    try { n = Number(localStorage.getItem(key())); } catch (e) {}
    if (allowed(n)) return n;
    var c = document.querySelector('[data-product-container]');
    var initial = c && Number((c.className.match(/\bm-cols-(\d)\b/) || [])[1]);
    return isMobile() ? 2 : (allowed(initial) ? initial : 4);
  }
  function apply(n) {
    var c = document.querySelector('.m-collection-products[data-product-container]');
    if (!c) return;
    c.className = c.className.replace(/\bm-cols-\d\b/g, '').replace(/\s+/g, ' ').trim() + ' m-cols-' + n;
    document.querySelectorAll('.fb-layout-btn').forEach(function (b) {
      b.classList.toggle('is-active', Number(b.dataset.column) === n);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.fb-layout-btn');
    if (!btn) return;
    var n = Number(btn.dataset.column);
    if (!allowed(n)) return;
    try { localStorage.setItem(key(), n); } catch (err) {}
    apply(n);
  });
  function init() {
    apply(stored());
    var grid = document.getElementById('CollectionProductGrid');
    // Filtering/sorting re-renders the grid: re-apply the chosen layout
    if (grid && window.MutationObserver) {
      new MutationObserver(function () { apply(stored()); }).observe(grid, { childList: true });
    }
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { apply(stored()); }, 200);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// Recently viewed: remember the colour that was viewed ("handle:variantId"),
// replacing the plain handle the theme's product.js stores.
(function () {
  var handle = window.MinimogSettings && window.MinimogSettings.productHandle;
  if (!handle || typeof window.getCookie !== 'function' || typeof window.setCookie !== 'function') return;
  var NAME = 'm-recent-viewed-products';

  function currentVariantId() {
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('.m-main-product form[action*="/cart/add"] [name="id"], .m-main-product [name="id"]');
    return input && input.value;
  }
  function save() {
    var id = currentVariantId();
    if (!id) return;
    var list = [];
    try { list = JSON.parse(window.getCookie(NAME) || '[]'); } catch (e) {}
    var pos = -1;
    list = list.filter(function (k, i) {
      var match = k === handle || k.indexOf(handle + ':') === 0;
      if (match && pos === -1) pos = i;
      return !match;
    });
    list.splice(pos === -1 ? 0 : pos, 0, handle + ':' + id);
    window.setCookie(NAME, JSON.stringify(list.slice(0, 20)));
  }
  window.addEventListener('load', save);
  window.addEventListener('pagehide', save);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.m-main-product')) setTimeout(save, 300);
  });
})();
